export const messages = {
  en: {
    partnerOrders: {
      queryCondition: 'Query Condition',
      orderIdPlaceholder: 'Please enter order number',
      personNamePlaceholder: 'Please enter receiver name',
      personTelPlaceholder: 'Please enter receiver phone',
      query: 'Query',
      partnerOrders: 'Partner Orders',
      transactionId: 'Transaction ID',
      orderId: 'Order ID',
      refund: 'Refund',
      totalPrice: 'Total Price',
      personName: 'Receiver',
      personTel: 'Receiver Phone',
      channel: 'Channel',
      createTime: 'Sync Time',
      state: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      detail: 'Detail',
      yes: 'Yes',
      no: 'No',
      syncSuccess: 'Sync Success',
      syncFail: 'Sync Fail'
    }
  },
  zh: {
    partnerOrders: {
      queryCondition: '查询条件',
      orderIdPlaceholder: '请输入订单编号',
      personNamePlaceholder: '请输入收货人',
      personTelPlaceholder: '请输入收货电话',
      query: '查询',
      partnerOrders: '合作订单',
      transactionId: '订单流水',
      orderId: '订单编号',
      refund: '退货单',
      totalPrice: '支付金额',
      personName: '收货人',
      personTel: '收货电话',
      channel: '渠道',
      createTime: '同步时间',
      state: '状态',
      remark: '说明',
      operation: '操作',
      detail: '详情',
      yes: '是',
      no: '否',
      syncSuccess: '同步成功',
      syncFail: '同步失败'
    }
  }
}